import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment StudentMilestone on student_milestones {
    id
    name
    due_date
    status
    user_id
    order
  }
  fragment StudentMilestoneExercise on student_milestone_exercises {
    id
    exercise_id
    milestone_id
    status
    due_date
    order
    response
    exercise {
      id
      module_id
      name
      meeting_type
    }
  }
  fragment vUser on v_students {
    user_id
    user_first_name
    user_last_name
    user_preferred_name  
    user_email
    user_cognito_username
    user_status
    last_login_at
    product_type
    user_cognito_sub
    is_trial
    trial_end_date
    graduation_year
    admin_id
    mbg_date
  }
`;

export const SEARCH_STUDENT = gql`
  query search($query: String!) {
    users(
      where: {
        user_type: { _eq: "student" }
        _or: [
          { user_first_name: { _ilike: $query } }
          { user_last_name: { _ilike: $query } }
          { user_email: { _ilike: $query } }
        ]
      }
      limit: 10
    ) {
      user_id
      user_first_name
      user_last_name
      user_email
    }
  }
`;

export const GET_ADMIN_STUDENTS = gql`
  query getStudents($product: String) {
    students: v_students(where: { product_type: { _eq: $product } }) {
      ...vUser
      lc_id
      hc_id
      lc_name
      hc_name
      fa_id
      fa_name
      group_student {
        id
        group {
          id
          name
          room_id
          sms_conversation_id
        }
      }
      subscriptions {
          id
          end_date
      }  
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_STUDENT_PROFILE = gql`
  mutation update($userId: Int!, $data: student_profile_set_input) {
    update_student_profile(where: { user_id: { _eq: $userId } }, _set: $data) {
      returning {
        user_id
      }
    }
  }
`;

export const CREATE_STUDENT_MILESTONES = gql`
  mutation create($data: [student_milestones_insert_input!]!) {
    insert_student_milestones(objects: $data) {
      returning {
        id
        student_milestone_exercises {
          due_date
          id
          response
        }
      }
    }
  }
`;

export const UPSERT_STUDENT_MILESTONE = gql`
  mutation update(
    $upsertMilestones: [student_milestones_insert_input!]!
    $deleteMilestones: [Int!]
    $deleteExercises: [Int!]
  ) {
    insert_student_milestones(
      objects: $upsertMilestones
      on_conflict: {
        constraint: student_milestones_pkey
        update_columns: [name, order, due_date]
      }
    ) {
      returning {
        id
        student_milestone_exercises {
          id
        }
      }
    }
    delete_student_milestones(where: { id: { _in: $deleteMilestones } }) {
      affected_rows
    }
    delete_student_milestone_exercises(
      where: { id: { _in: $deleteExercises } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_MILESTONE_EXERCISES = gql`
  mutation deleteExercises($deleteExercises: [Int!]) {
    delete_student_milestone_exercises(
      where: { id: { _in: $deleteExercises } }
    ) {
      affected_rows
    }
  }
`;

export const GET_STUDENT_MILESTONES = gql`
  query getStudentMilestones($userId: Int!) {
    student_milestones(
      where: { user_id: { _eq: $userId } }
      order_by: [{ order: asc }]
    ) {
      ...StudentMilestone
      student_milestone_exercises(order_by: [{ order: asc }]) {
        ...StudentMilestoneExercise
      }
    }
  }
  ${FRAGMENTS}
`;

export const INSERT_STUDENT_MILESTONE_EXERCISE = gql`
  mutation insertMilestoneExercise(
    $data: student_milestone_exercises_insert_input!
  ) {
    response: insert_student_milestone_exercises_one(object: $data) {
      id
      response
      due_date
    }
  }
  ${FRAGMENTS}
`;

export const GET_FA_EXERCISE_ID = gql`
  query getFAexerciseID {
    exercises(where: { meeting_type: { _eq: "fa" } }) {
      name
      id
    }
  }
  ${FRAGMENTS}
`;
